<template>
    <div>
        <div id="home" class="home" v-if="accountSelected.accountId != ''">
            <div v-if="$store.getters.isUserImpersonated" class="impersonatedUserHeader">
                You are impersonating the user : {{$store.getters.username}}
            </div>
            <div v-if="$store.getters.isAccountImpersonated" class="impersonatedUserHeader">
                You are impersonating the customer account: {{$store.getters.impersonatedAccount}} - {{getImpersonatedAccountName}}
            </div>
            <Header />
            <div class="container">
                <PageTitle />
                <AccountUser ref="accountUser" :defaultAccount="accountSelected" v-if="$store.getters.username != ''" />
            </div>
        </div>
        <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    </div>
</template>

<script>
    import Header from "./shared/Header";
    import PageTitle from "./shared/PageTitle";
    import AccountUser from "./AccountUser";
    import service from "../services/api.services";
    import { Component as Loading } from "vue-loading-overlay";
    import { setTimeout } from "core-js";

    export default {
        name: "Home",
        components: {
            Header,
            PageTitle,
            AccountUser,
            Loading
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                accountSelected: { accountName: "", accountNumber: "", accountId: "", hideInactiveContact:false }
            };
        },
        computed: {
            username: function () {
                return this.$store.getters.username;
            },
            getImpersonatedAccountName: function () {
                let accountNo = this.$store.getters.impersonatedAccount;
                return this.$store.getters.adminAccounts.filter(p => p.accountNumber == accountNo)[0].accountName;
            }
        },
        watch: {
            username() {
                location.reload();
            }
        },
        mounted() {
            var that = this;
            that.isLoading = true;
            service
                .GetLoggedInUserInfo()
                .then(() => {
                    sessionStorage.removeItem("um_home_reloaded");
                    this.$store.dispatch("setFirstLoadCompleted");
                    var primaryAccount = that.$store.getters.primaryAccount;
                    let accounts = that.$store.getters.adminAccounts;
                    if (accounts == null || accounts.length == 0) {
                        that.$router.push('unauthorize');
                    }
                    else {
                        that.isLoading = false;

                        //Set Selected Account
                        if (typeof that.$route.query.accountNo != "undefined") {
                            var result = accounts.find(({ accountNumber }) => accountNumber === that.$route.query.accountNo);
                            if (typeof result != "undefined" || result != null)
                                that.accountSelected = result;
                            //that.$router.push({ path: that.$route.path })
                        }
                        else if (typeof primaryAccount != "undefined") {
                            var primaryAccResult = accounts.find(({ accountId }) => accountId === that.$store.getters.primaryAccount);
                            if (typeof primaryAccResult != "undefined" || primaryAccResult != null)
                                that.accountSelected = primaryAccResult;
                        }
                        else
                            that.accountSelected = accounts[0];

                        if (typeof that.$route.query.accountNo != "undefined")
                            that.$router.push({ path: that.$route.path })

                        if (that.accountSelected.accountNumber == null || that.accountSelected.accountNumber == "")
                            that.accountSelected = accounts[0];

                        setTimeout(() => {
                            this.$refs.accountUser.setEmits();
                        }, 10);
                    }
                })
                .catch(error => {
                    this.$store.dispatch("setFirstLoadCompleted");
                    if (error != "InvalidToken")
                        this.isLoading = false;
                    this.$store.dispatch("setPageLoadedValue", true);
                    var is401 = error && error.toString().toLowerCase().indexOf("status code 401") !== -1;
                    if (is401 && !sessionStorage.getItem("um_home_reloaded")) {
                        sessionStorage.setItem("um_home_reloaded", "1");
                        location.reload();
                    }
                    this.isPageLoaded = this.$store.getters.isPageloaded;
                    console.log("api error:" + error);
                });
            window.addEventListener("beforeunload", function (event) {
                //Clearing the localstorage if the request is not from API
                //As silentauth also trigger this code,
                //so isApiRequested is set as true from triggerSilentLogin and after complete it is set back to false
                if (that.$store.getters.isPageDirty) {
                    event.returnValue = "Write something";
                }
                if (!that.$store.getters.isApiRequested) {
                    var keys = Object.keys(localStorage),
                        i = keys.length;
                    while (i--) {
                        if (keys[i].startsWith("oidc"))
                            localStorage.removeItem(keys[i]);
                    }
                }
                else {
                    that.$store.dispatch("resetIsApiRequested");
                }
            });
        },
    };
</script>
